import { LoadingInterfaceTypesEnum } from 'constants/types/Loading';
import { IReduxAction } from 'constants/types/IReduxAction';
const initialState: LoadinState = {
  loadingProcesses: 0,
  loading: false,
};

export interface LoadinState {
  loadingProcesses: number;
  loading: boolean;
}

export default (
  state: LoadinState = initialState,
  action: IReduxAction,
): LoadinState => {
  let { loadingProcesses, loading } = state;
  const { type } = action;
  switch (type) {
    case LoadingInterfaceTypesEnum.LOADING_START:
      loadingProcesses += 1;
      loading = true;
      return { loadingProcesses, loading };
    case LoadingInterfaceTypesEnum.LOADING_FINISHED:
      loadingProcesses -= 1;
      if (loadingProcesses === 0 || loadingProcesses <= 0) {
        loading = false;
        loadingProcesses = 0;
      }
      return { loadingProcesses, loading };
    default:
      return state;
  }
};
